import React from "react";
import { FileRevisionDto } from "../../../../../../models/interfaces/dtos/file-revision-dto.ts";
import ValidationPack from "../../models/validation-pack.ts";
import PackData from "../../layouts/details/models/pack-data.ts";

export interface ValidationContextProps {
    isLoading: boolean;    

    validationPacks: ValidationPack[] | undefined;
    fileRevisions: FileRevisionDto[] | undefined;
    packsData: Map<string, PackData>;

    acceptPack: (packId: string, validationId: string) => Promise<void>;
    refusePack: (packId: string, validationId: string) => Promise<void>;

    refreshData: () => Promise<void>;
}

export const ValidationContext = React.createContext<ValidationContextProps | undefined>(undefined);